var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M24.563 12.54a12 12 0 0 1-19.532 9.366 1.16 1.16 0 0 1-.089-1.723l.545-.545a1.163 1.163 0 0 1 1.543-.1 8.9 8.9 0 1 0-.568-13.463l2.456 2.456a.774.774 0 0 1-.547 1.322H1.337a.774.774 0 0 1-.774-.774V2.044A.774.774 0 0 1 1.884 1.5l2.389 2.386a12 12 0 0 1 20.29 8.654zm-8.754 3.812l.475-.611a1.161 1.161 0 0 0-.2-1.63l-1.969-1.532V7.53a1.161 1.161 0 0 0-1.165-1.161h-.774a1.161 1.161 0 0 0-1.162 1.161v6.564l3.165 2.462a1.161 1.161 0 0 0 1.63-.2z",
    transform: "translate(-.563 -.563)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.e99069657bebb792890522c5fc474405.svg";
export { ForwardRef as ReactComponent };